import React from 'react'
// @ts-ignore
import { Bar } from '@netbasequid/chart'
import { useDisplayTheme } from '../../../hooks/useUiState'

export type BarSelection = {
  category: string
  seriesName: string
  x: number
  y: number
  custom: any
}

type BarChartProps = {
  type?: 'bar' | 'column'
  data: {
    data: (
      | {
          y: number
          custom: any
        }
      | number
    )[]
  }[]
  xCategories: string[]
  xAxisTitle?: string
  yAxisTitle?: string
  showDataLabels?: boolean
  colorSetting?: string
  xAxisLabelStyle?: string
  yAxisAllowDecimals?: boolean
  stacking?: 'default' | 'value' | 'percent'
  seriesHeader?: string
  showComparison?: boolean
  yAxisLabelFormatter?: (label: any) => string
  tooltipFormatter?: (point: any) => string
  tooltipValueFormatter?: (point: any) => string
  showGridLineY?: boolean
  showTickX?: boolean
  showTickY?: boolean
  dataLabelColor?: string
  tickInterval?: number
  xAxisStep?: number
  dataLabelFormatter?: (point: any) => string | null | number
  hideOverlapDataLabels?: boolean
  onClick?: ({ category, seriesName, x, y, custom }: BarSelection, event: any) => void
}

const BarChart = ({
  type = 'bar',
  data,
  xCategories,
  xAxisTitle = '',
  yAxisTitle = '',
  showDataLabels,
  colorSetting,
  xAxisLabelStyle,
  yAxisAllowDecimals,
  stacking = 'default',
  seriesHeader,
  showComparison,
  yAxisLabelFormatter,
  tooltipFormatter,
  tooltipValueFormatter,
  showGridLineY,
  showTickX,
  showTickY,
  dataLabelColor,
  tickInterval,
  xAxisStep,
  dataLabelFormatter,
  hideOverlapDataLabels,
  onClick
}: BarChartProps) => {
  const theme = useDisplayTheme()

  return (
    <Bar
      type={type}
      xCategories={xCategories}
      xAxisTitle={xAxisTitle}
      yAxisTitle={yAxisTitle}
      data={data}
      mode={theme}
      showDataLabels={showDataLabels}
      colorSetting={colorSetting}
      xAxisLabelStyle={xAxisLabelStyle}
      yAxisAllowDecimals={yAxisAllowDecimals}
      stacking={stacking}
      seriesHeader={seriesHeader}
      showComparison={showComparison}
      yAxisLabelFormatter={yAxisLabelFormatter}
      tooltipFormatter={tooltipFormatter}
      tooltipValueFormatter={tooltipValueFormatter}
      showGridLineY={showGridLineY}
      showTickX={showTickX}
      showTickY={showTickY}
      dataLabelColor={dataLabelColor}
      tickInterval={tickInterval}
      xAxisStep={xAxisStep}
      dataLabelFormatter={dataLabelFormatter}
      hideOverlapDataLabels={hideOverlapDataLabels}
      onClick={onClick}
    />
  )
}

export default BarChart
